import Link from "next/link";
import { Col, Row } from "react-styled-flexboxgrid";
import styled from "styled-components";
import { Color } from "../../theme/Color";
import { FontSizes } from "../../theme/FontSize";

interface Props {
  title: string;
  link: string;
  isActive?: boolean;
  menuItemType?: string;
  setShowMenu?: (boolean) => any;
}

const StyledLink = styled.a<{ menuItemType?: string }>`
  ${({ menuItemType }) => handleSpacing(menuItemType)};
  display: block;
  text-decoration: none;
  color: ${Color.Black};
  font-weight: bold;
  cursor: pointer;

  &.active {
    color: ${Color.Black};
  }
`;

const handleSpacing = (menuItemType) => {
  switch (menuItemType) {
    case "parent":
      return `
        padding: 0.85rem 1rem 0.85rem 2rem;
        margin: 0rem;
        font-size: ${FontSizes[2]};
      `;
    case "child":
      return `
        padding: 0rem 0.35rem 0rem 3.5rem;
        margin: 0rem;
        font-size: ${FontSizes[-1]};
      `;
    default:
      return `
        padding: 0.85rem 1rem 0.85rem 2rem;
        margin: 0.6rem 0rem 0.6rem 0rem;
        font-size: ${FontSizes[2]};
      `;
  }
};

const MobileMenuItem = ({
  title,
  link,
  isActive = false,
  menuItemType = "default",
  setShowMenu,
}: Props) => {
  return (
    <Col xs={12}>
      <Row center="xs" style={{}}>
        <Col xs={12}>
          <Link href={link} passHref>
            <StyledLink
              className={isActive ? "active" : "not-active"}
              menuItemType={menuItemType}
              onClick={() => {
                setShowMenu(false);
              }}
            >
              {title}
            </StyledLink>
          </Link>
        </Col>
      </Row>
    </Col>
  );
};

export default MobileMenuItem;
